import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=702de1b2&scoped=true&lang=pug"
import script from "./BatchList.vue?vue&type=script&lang=ts"
export * from "./BatchList.vue?vue&type=script&lang=ts"
import style0 from "./BatchList.vue?vue&type=style&index=0&id=702de1b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702de1b2",
  null
  
)

export default component.exports